import React from 'react';

export default function Skip({
  color = '#292F36',
  className,
  direction = 'right',
  height = 9,
  onClick = () => {},
  width = 13,
  style = {},
}) {
  const transform =
    direction === 'left'
      ? `translate(${width}, 0) scale(-1, 1)`
      : 'translate(0, 0)';
  return (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      viewBox="0 0 13 9"
      className={className || ''}
    >
      <title>Go to {direction === 'left' ? 'prev' : 'next'} audio</title>
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        transform={transform}
      >
        <g fill={color}>
          <polygon points="0.686282907 0.206411089 0.686282907 8.33151611 6.95454545 4.2689636" />
          <polygon points="6.48173745 0.206411089 6.48173745 8.33151611 12.75 4.2689636" />
        </g>
      </g>
    </svg>
  );
}
